import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { getBoardList } from '@api/api';
import { BOARD_NOTICE_CODE } from '@common/utils/board';

const HomeMainNotice = () => {
  const [postInfos, setPostInfos] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const initPostInfos = async () => {
      const params = {
        bbsClssCd: BOARD_NOTICE_CODE,
        targetRow: 1,
        rowSize: 5,
      };

      const { postInfos } = await $utils.fetchPosts(params, getBoardList);

      if (isMounted) setPostInfos(postInfos);
    };

    initPostInfos();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="app-box-main max-h30">
      <div className="ico-group-2 ico-new-notice">
        <h3 className="tit3">공지사항</h3>
      </div>

      <ul className="notice-board-list">
        {postInfos.length > 0 ? (
          postInfos.map(
            ({ bbsSno, bbsTitle, newBbsYn, atchFileYn, fstRegDdtm }, index) => (
              <li
                key={index}
                className={$classNames('new', {
                  'border-none': index === postInfos.length - 1,
                })}
              >
                <Link to={`/notice/detail?postId=${bbsSno}`}>
                  <span className="txt">{bbsTitle}</span>

                  {newBbsYn === 'Y' && <em className="ico ico-new">new</em>}
                  {atchFileYn === 'Y' && (
                    <em className="ico ico-add-file">file</em>
                  )}

                  <span className="date">
                    {format(new Date(fstRegDdtm), 'yyyy.MM.dd')}
                  </span>
                </Link>
              </li>
            ),
          )
        ) : (
          <li>
            <div className="round-box bd-type no-data">게시물이 없습니다.</div>
          </li>
        )}

        <Link className="ico-arrow" to="/notice/list">
          더보기
        </Link>
      </ul>
    </div>
  );
};

export default HomeMainNotice;
